/* eslint-disable max-len */
import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

export const FormatTypeTable = ({content}) => {
    return (
        <div className="responsive-table">
            <h3>FORMAT TYPES:</h3>
            <table className="format-type" cellSpacing="0" cellPadding="0">
                <thead>
                    <tr>
                        <th className="col">FORMAT TYPE (STRING)</th>
                        <th className="col-description wide">FORMAT INFO</th>
                        <th className="col">MEDIA FILTERS SUPPORTED</th>
                    </tr>
                </thead>
                {content.map( (row) => {
                    return (
                        <tbody>
                            <tr>
                                <td>
                                    <div className="table-bold-text">{row.type}</div>
                                </td>
                                <td className="col-description wide">
                                    <p><b>Resolution and size: </b>{row.info.resolution}</p>
                                    <p><b>Dimensions: </b>{row.info.dimensions}</p>
                                    <p><b>Usage Notes: </b> {row.info.usage}</p>
                                </td>
                                <td>
                                    {row.filters}
                                </td>
                            </tr>
                            <tr className="col-description narrow">
                                <td colSpan={3}>
                                    <div className="mobile-heading">Format Info</div>
                                    <div>
                                        <p><b>Resolution and size: </b>{row.info.resolution}</p>
                                        <p><b>Dimensions: </b>{row.info.dimensions}</p>
                                        <p><b>Usage Notes: </b> {row.info.usage}</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    );
                })}
            </table>
        </div>
    );
};
